module.exports = __webpack_public_path__ + "static/media/instagram-icon.f7a7c1ca.svg";